"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwLabel = _interopRequireDefault(require("../../cwlabel/CwLabel"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellLink = function CellLink(props) {
  var id = "".concat(props.row.id, ":").concat(props.col.key);
  var value = props.row[props.col.key];
  return _react.default.createElement("div", {
    "data-cw-grid-cell-link": true,
    className: _CwDataGrid.default.cell,
    id: id,
    style: {
      width: props.col.width
    }
  }, _react.default.createElement(_CwLabel.default, {
    value: value || '--',
    onClick: function onClick() {
      if (typeof props.col.onClick === 'function' && typeof value === 'string' && value.length > 0) {
        props.col.onClick(value, props.row);
      }
    },
    isLink: typeof value === 'string' && value.length > 0
  }));
};

CellLink.propTypes = {
  col: _propTypes.default.object.isRequired,
  row: _propTypes.default.object.isRequired
};
var _default = CellLink;
exports.default = _default;